/**
 * 房间信息
 */

import React from 'react';
import styled from 'styled-components';

const RoomBase = (props) => {
  const { pic, roomId, uid, nickname } = props.item;
  return (
    <Wrap className="info">
      <img
        className="info-avatar"
        src={pic || 'https://img.sumeme.com/3/3/1559108259459.png'}
      />
      <p className="info-nick  text-overflow">{nickname}</p>
      <span className="info-desc">ID: {roomId || uid}</span>
    </Wrap>
  );
};

const Wrap = styled.div`
  text-align: center;
  ._dark & {
    .info-nick {
      color: #ffffff;
    }
  }
  .info {
    &-avatar {
      width: 80px;
      height: 80px;
      border-radius: 100%;
      margin: auto;
    }
    &-nick {
      font-size: 14px;
      font-weight: 500;

      display: block;
      margin: 4px 0 0;
    }
    &-desc {
      font-size: 12px;
      font-weight: 400;
      color: #8a8aa2;
    }
  }
`;

export default RoomBase;
